var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyTooLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 37,
    viewBox: "0 0 69 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M65.9224 23.8706C62.9303 20.884 58.0791 20.884 55.087 23.8706C52.0949 26.8572 52.0949 31.6994 55.087 34.686C58.0791 37.6725 62.9303 37.6725 65.9224 34.686C68.9145 31.6994 68.9145 26.8572 65.9224 23.8706Z",
    fill: "#760731"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M65.916 23.8732C62.9239 20.8866 58.0727 20.8866 55.0806 23.8732L44.3799 34.554C41.3878 37.5406 36.5366 37.5406 33.5445 34.554C30.5524 31.5674 30.5524 26.7252 33.5445 23.7386L44.2451 13.0578C47.2373 10.0713 52.0884 10.0713 55.0806 13.0578L65.916 23.8732Z",
    fill: "#760731"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0801 13.0553C52.088 10.0688 47.2368 10.0688 44.2447 13.0553L23.4768 33.7848C19.4873 37.7669 13.019 37.7669 9.02952 33.7848L0 24.772C2.99212 27.7586 7.84331 27.7586 10.8354 24.772L33.4092 2.23997C36.4014 -0.746605 41.2526 -0.746605 44.2447 2.23998L55.0801 13.0553Z",
    fill: "#760731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyTooLogo);
export default __webpack_public_path__ + "static/media/money-too-logo.33282eeaf4d324515275ba7589798672.svg";
export { ForwardRef as ReactComponent };